	import { FC, useCallback, useContext, useEffect, useState } from "react";
	import { useHistory } from "react-router-dom";

	import { BoardContext, TeamContext, UserContext } from "../context";
	import { ReJoinTheGame } from "../components/molecules";
	import { BoardPage } from "../pages";
	import { Phase } from "../util/enums";
	import { IPlayer } from "../interfaces";
	import { ConnectionFailedPage, MuteButton } from "../components/atoms";

	const BoardRoute: FC<{}> = () => {
	const { teamNumber, game, urlToken, gameId } = useContext(TeamContext);
	const { userData } = useContext(UserContext);
	const [showButtonToRefreshAutomatically, setShowButtonToRefreshAutomatically ] = useState<boolean>(false);
	const areInGamePhasesActive = (game?.phase === Phase.CHOOSING_SOLUTION_CARDS || game?.phase === Phase.INTRODUCTION ||  game?.phase === Phase.PICK_DILEMMA || game?.phase === Phase.QUESTION_CARD || game?.phase === Phase.ACTION_CARD || game?.phase === Phase.CHOOSE_SOLUTION || game?.phase === Phase.RENDER_SPIN_WHEEL || game?.phase === Phase.SOLUTION_CHOSEN || game?.phase === Phase.SOLUTION_CHOSEN_REWARD || game?.phase === Phase.CONFETTI_CELEBRATION);


	console.log({teamNumber, game, urlToken, gameId});
	const checkIfAnyOfTheUsersLoggedOutDuringTheGame = useCallback (() => {
		let listOfThePlayers = game?.gameInfo?.players;
		let helperArray = [];
		
		for (const playerEmail in listOfThePlayers) {
			if (listOfThePlayers[playerEmail].status === 3) {
				let expectedPlayer = game?.players.find((player: IPlayer) => { return player.email === playerEmail });
				
				if (expectedPlayer)
					helperArray.push(expectedPlayer);
			}
		}
	},[game?.gameInfo?.players, game?.players])

	useEffect(() => {
		checkIfAnyOfTheUsersLoggedOutDuringTheGame();
	}, [game?.gameInfo?.players, checkIfAnyOfTheUsersLoggedOutDuringTheGame]);

	let history = useHistory();

	const myEmail = localStorage["userEmailInCaseHeLogsOut"];
	const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];
	
	const postStatisticInfo = useCallback(() => {
		let data = {
			matchId: urlTokenExtracted,
			gameId: urlTokenExtracted,
			email: myEmail,
		}

		fetch(process.env.REACT_APP_BACKEND_URL + "api/post-games/statistic", {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})
			.then(res => res.json()).then(data => {
				history.push("/statistics/" + urlToken); 
			})
			.catch((err) => {
				console.error(err);
			});
	}, [gameId, history, myEmail, urlToken, urlTokenExtracted]);

	useEffect(() => {
		if (game?.phase === Phase.POSTGAME)
			postStatisticInfo();
	}, [postStatisticInfo, game]);

	return (
		<div>
			<div>
				{/* {!game && !showButtonToRefreshAutomatically && <button onClick={() => setShowButtonToRefreshAutomatically(true)}>  join by force </button>} */}
				{!game && showButtonToRefreshAutomatically && <ConnectionFailedPage />}
				{(!teamNumber || !userData) && !game && <ReJoinTheGame />}
				{(!teamNumber || !userData) && game && <BoardPage />}
				{teamNumber && userData && areInGamePhasesActive && <BoardPage />}
				<MuteButton />
			</div>
		</div>
	);
}

export default BoardRoute;